var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-main"},[_c('Header2'),_c('div',{staticClass:"header-placeholer"}),_c('div',{staticClass:"main"},[_c('div',{staticClass:"menu-wrap"},[_c('MenuSlider',{attrs:{"menuList":_vm.routerData,"default-active":_vm.activePath}})],1),_c('main',[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }